import {observer} from "mobx-react";
import React from "react";
import {FormProps} from "../../core/form/formUtils";
import {DefinitionType} from "../../core/form/form";
import { MdTextField} from "../../core/components/fields/fields";
import {Validate} from "../../core/form/validate";
import {createForm} from "../../core/form/createForm";
import {ProjectVersionRunoffCoefficient} from "../domain/project/projectRunoffCoefficientDomain";
import {ProjectVersion} from "../domain/project/projectVersionDomain";

@observer
class ProjectVersionRunoffCoefficientForm extends React.Component<FormProps<ProjectVersionRunoffCoefficient, ProjectVersion>, any> {

  render(): JSX.Element | false | null {
    let {dataObject} = this.props;
    let fields = dataObject.getFormFields(ProjectRunoffCoefficientFormDefinition.formName);
    let { name, lower,between,over} = fields;
    console.log("runoffCoefficient PROPS",this.props)



    return (
      <div>
        <div className='row'>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...name.props}/>
            <Validate field={name} value={name.props.value} />
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...lower.props}/>
            <Validate field={lower} value={lower.props.value} />
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...between.props}/>
            <Validate field={between} value={between.props.value} />
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...over.props}/>
            <Validate field={over} value={over.props.value} />
          </div>
        </div>
      </div>
    );
  }
}


export const ProjectRunoffCoefficientFormDefinition: DefinitionType = {
  formName: 'ProjectVersionRunoffCoefficientForm',
  fields: [
    {name : 'name', validators:['IsRequired']},
    {name : 'lower', validators:['IsNumber', 'IsRequired',{validation: 'Max', parameters: {max: 1}}]},
    {name : 'between',validators:['IsNumber', 'IsRequired',{validation: 'Max', parameters: {max: 1}}]},
    {name : 'over',validators:['IsNumber', 'IsRequired',{validation: 'Max', parameters: {max: 1}}]},
  ]
};

export default createForm(ProjectRunoffCoefficientFormDefinition, null)(ProjectVersionRunoffCoefficientForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectRunoffCoefficientForm.tsx